<!-- 팝업 설정 미리보기 팝업 -->
<template>
<transition name="modal" appear>
    <div class="modal modal-overlay">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content w-400px">
                <div class="modal-body">
                    <div>
                        <a href="#" class="float-right layer-close ml-30 mb-10" data-dismiss="modal" aria-label="Close">
                            <img src="../../../assets/img/close.png" @click="$emit('close')" alt="close" class="close-btn">
                        </a>
                        <h3 class="font-14 bold">{{title}}</h3>
                        <p class="preline font-13 pt-20 pb-20 preview-popup" v-html="content">
                            팝업 내용입니다. 팝업 내용입니다. 팝업 내용입니다. 팝업 내용입니다.
                            팝업 내용입니다. 팝업 내용입니다. 팝업 내용입니다.
                            팝업 내용입니다. 팝업 내용입니다. 팝업 내용입니다.

                            팝업 내용입니다.
                            팝업 내용입니다. 팝업 내용입니다.

                            팝업 내용입니다. 팝업 내용입니다. 팝업 내용입니다.

                            팝업 내용입니다. 팝업 내용입니다.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</transition>
</template>

<script>
export default {
    props: ['editorContent', 'titleContent'],
    data: () => ({
        title: '', // 팝업 제목
        content: '' // 팝업 내용(ckEditor 사용)
    }),

    mounted() {
        console.log('열림')
        this.title = this.titleContent
        this.content = this.editorContent
    }
}
</script>

<style lang="scss" scoped>
.modal {
    &.modal-overlay {
        display: flex;
        align-items: center;
        justify-content: center;
        position: fixed;
        z-index: 30;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
    }

    &-window {
        border-radius: 4px;
        overflow: hidden;
    }

    &-content {
        padding: 10px 20px;
    }
}

.modal-enter-active,
.modal-leave-active {
    transition: opacity 0.4s;

    .modal-window {
        transition: opacity 0.4s, transform 0.4s;
    }
}

.modal-leave-active {
    transition: opacity 0.6s ease 0.4s;
}

.modal-enter,
.modal-leave-to {
    opacity: 0;

    .modal-window {
        opacity: 0;
        transform: translateY(-20px);
    }
}
</style>
